module.exports = __webpack_public_path__ + "static/media/400003_01.3c0bb597.png";